import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";

import { PermissionsService } from "@intocare/auth-data";

export const PermissionsGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	return inject(PermissionsService).canActivate(next, state);
};
